import { combineReducers } from "redux";
import loginReducer from './loginReducer';

import landingReducer from './landing'; 
import uploadtaskReducer from './uploadtask';
import userReducer from './user';

const reducers = combineReducers({
    login: loginReducer,
    landing : landingReducer,
    uploadtask : uploadtaskReducer,
    user: userReducer,
})

export default reducers;
export type RootState = ReturnType<typeof reducers>;